import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-sort-alpha-up',
  templateUrl: './icon-sort-alpha-up.component.html',
  styleUrls: ['./icon-sort-alpha-up.component.scss']
})
export class IconSortAlphaUpComponent implements OnInit {
  @Input() color = '#262628';
  @Input() size = 18;

  constructor() { }

  ngOnInit() {
  }

}
